import { c as _c } from "react/compiler-runtime";
import { BaseEmbed, type Props } from '@cc-shopping/ui/composites/BaseEmbed';
import type { StructuredContentDocumentWithRenderer } from '../../hydration/types';
type WPEmbedProps = StructuredContentDocumentWithRenderer<{
  props: Props;
}> & {
  props: Props;
};
export function WPEmbed(t0) {
  const $ = _c(2);
  const {
    props
  } = t0;
  let t1;
  if ($[0] !== props) {
    t1 = <BaseEmbed {...props} />;
    $[0] = props;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}